<template>
  <div class="page-content"  id="retained">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>渠道档案</el-breadcrumb-item>
      <el-breadcrumb-item>资料留存</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="标题" :label-width="formLabelWidth">
          <el-input placeholder="请输入" v-model="title" autocomplete="on" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间" :label-width="formLabelWidth">
          <el-date-picker
            v-model="searchformDate"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="~"
            :picker-options="pickerOptions"
            size="small"
            :clearable="false"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
        </el-form-item>
      </el-form>
    </section>

    <div class="page">
      <div class="downBtn">
        <el-button size="small" type="primary" @click="newAdd()" icon="el-icon-plus">新增</el-button>
        <el-button size="small" @click="getLogPage">操作记录</el-button>
        <el-button size="small" @click="onOpenDeleteDia(2)">批量删除</el-button>
      </div>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{totalNum}}</span>项,已选择<span class="promptFont">{{openNumber}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <el-table
        @selection-change="handleSelectionChange"
        :data="tableData"
        ref="multipleTable"
        v-loading="dataLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%;"
        >
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="标题">
          <template slot-scope="scope">
            <div style="line-height: 30px;height: 30px;">
              <img style="width: 30px;height: 30px;float: left;" :src='require("@/assets/img/fileType/"+scope.row.postfix+".png")'/>
              <el-tooltip class="item" effect="dark" :content="scope.row.filename" placement="top-start">
                <div style="float: left;padding-left: 10px;width: 400px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                  {{scope.row.filename}}
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数据更新时间">
          <template slot-scope="scope">
            {{scope.row.createtime | fullTime}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="jump(scope.row.filename)">下载</el-button>
            <el-button type="text" @click="onOpenDeleteDia(1,scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length >= 1">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>

      <!-- 操作记录 -->
      <el-dialog
        title="操作记录"
        :visible.sync="logShow"
        width="840px" id="dialog">
        <el-row style="margin: 20px 0;">
          <el-col :span="12">
            <div style="display: flex;height: 32px;line-height: 32px;margin-bottom: 20px;">
              <div style="width: 93px;text-align: right;">
                操作人
              </div>
              <el-input placeholder="请输入" v-model="opreate_realname" autocomplete="on" size="small" clearable style="width: 300px;margin-left: 10px;"></el-input>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="display: flex;height: 32px;line-height: 32px;margin-bottom: 20px;">
              <div style="width: 93px;text-align: right;">
                动作
              </div>
              <el-select v-model="opreate" placeholder="请选择" size="small" clearable style="width: 300px;margin-left: 10px;">
               <el-option
                 v-for="item in options"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value">
               </el-option>
             </el-select>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="display: flex;height: 32px;line-height: 32px;margin-bottom: 20px;">
              <div style="width: 93px;text-align: right;">
                开始时间
              </div>
              <el-date-picker
                style="width: 300px;margin-left: 10px;"
                size="small"
                value-format="yyyy-MM-dd"
                v-model="starttime"
                type="date"
                :clearable="false"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="display: flex;height: 32px;line-height: 32px;margin-bottom: 20px;">
              <div style="width: 93px;text-align: right;">
                结束时间
              </div>
              <el-date-picker
                style="width: 300px;margin-left: 10px;"
                size="small"
                value-format="yyyy-MM-dd"
                v-model="endtime"
                type="date"
                :clearable="false"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="display: flex;height: 32px;line-height: 32px;">
              <div style="width: 93px;text-align: right;">
                操作文件
              </div>
              <el-input placeholder="请输入" v-model="filename" autocomplete="on" size="small" clearable style="width: 300px;margin-left: 10px;"></el-input>
            </div>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-button size="small" class="search-btn" @click="getLogPage()">查询</el-button>
          </el-col>
        </el-row>
        <div style="height: 500px;overflow: auto;">
          <el-table
            :data="logData"
            ref="multipleTable"
            style="width: 100%;"
            >
            <el-table-column label="操作人" prop="opreate_realname"></el-table-column>
            <el-table-column label="动作" prop="opreate"></el-table-column>
            <el-table-column label="操作文件" prop="filename"></el-table-column>
            <el-table-column label="操作时间">
              <template slot-scope="scope">
                {{scope.row.createtime | fullTime}}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="logShow = false" size="small" type="TheCustom">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 删除 -->
      <el-dialog
        title="提示"
        :visible.sync="deleteShow"
        width="360px" style="margin-top: 10%;" id="dialog">
          <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
            <div>
              <div style="font-size: 16px;">
                你确认要删除<span>{{delType}}</span>数据吗？
              </div>
              <div style="font-size: 14px;">删除后
                <span style="color: #e90e24;font-size: 14px;">
                  数据将无法恢复
                </span>
              </div>
            </div>
          </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="deleteClassification" size="small" :loading="ficationLoading">确 定</el-button>
          <el-button @click="delCancel" size="small" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 新增 -->
      <el-dialog
  			:title="editorTitle"
  			:visible.sync="downDataDialog"
  			:close-on-click-modal="false"
  			width="550px"
        id="typeDialog">
        <el-upload
          style="padding: 20px;border-radius: 15px;margin: 8px 0;border: 1px dashed #d9d9d9;"
          ref="newupload"
          class="upload-demo"
          action="hcm/cus/headUpload"
          :auto-upload="false"
          multiple
          accept=".xls,.xlsx,.csv,.txt,.text,.doc,.docx,.svg,.png,.jpg,.zip,.tar,.rar,.7z"
          :file-list="fileList"
          :on-success="confirmUpload"
        >
          <i class="el-icon-upload" style="color: #BDA571;"></i>
          <div class="el-upload__text" style="font-size: 16px;color: #333333;">点击上传</em>
            <p>点击这里选择文件上传</p>
            <p>支持扩展名：.xls .xlsx .csv .txt .text .doc .docx .svg .png .jpg .zip .tar .rar .7z</p>
          </div>
        </el-upload>
  			<span slot="footer">
  				<el-button size="small" class="g-confirm-btn" :loading="downloadLoading" @click="determine" type="primary">确 定</el-button>
  				<el-button size="small" class="g-cancel-btn" @click="downDataDialog = false">取 消</el-button>
  			</span>
  		</el-dialog>
    </div>
  </div>
</div>
</template>

<script>
  import pagination from "../../components/dataTable/pagination";
  import { getLoginType } from "@/libs/until";
  import axios from 'axios'
  export default {
    data() {
      return {
        options: [{
          label: '新增',
          value: '新增',
        },{
          label: '删除',
          value: '删除',
        }],
        opreate_realname: '',
        opreate: '',
        filename: '',
        starttime: '',
        endtime: '',
        logShow: false,
        editorTitle: "",
        fileList: [],
        pickerOptions: {
  				shortcuts: [{
            text: '今日',
            onClick:(picker) => {
  						this.getRecentDate(picker,1);
  					}
          },{
            text: '近7日',
            onClick:(picker) => {
  						this.getRecentDate(picker,7);
  					}
          }, {
  					text: '近15日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,15);
  					}
  				}, {
  					text: '近30日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,30);
  					}
  				}, {
  					text: '近90日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,90);
  					}
  				}, {
  					text: '近365日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,365);
  					}
  				}]
  			},
        id: '',
        LoadReportTemplat: false,
        downDataDialog: false,
        downloadLoading: false,
        delType: '',
        checkAll: '',
        ficationLoading: false,
        deleteShow: false,
        dataLoading: false,
        pageNo: 1,
        currentPage: 1,
        pageSize: 10,
        tableData: [],
        selectRows: [],
        searchformDate: [],
        delIds: [],
        totalNum: 100,
        formLabelWidth: '100px',
        openNumber: 0,
        title: '',
        logData: [],
      }
    },
    mounted() {
      this.theQuery()
    },
    methods: {
      jump(filename) {
        // let url
        // if (window.location.href.indexOf('https://brm.olonger.com') != -1) {
        //   url = "https://brm.olonger.com"
        // } else {
        //   url = "https://console.olonger.com/"
        // }
        let newUrl = "/hcm/hcmWorkOrder/downLoadFile?filename=keep/" + filename
        window.open(newUrl, '_blank');
      },
      // 确定上传
      confirmUpload(response) {
        if (response.status == 10000) {
          this.$message({
            message: response.message,
            type: 'success'
          });
          this.$refs.newupload.clearFiles();
          this.theQuery();
        } else {
          this.theQuery();
          this.$message.error(response.message);
          this.$refs.newupload.clearFiles();
        }
        this.downloadLoading = false
        this.downDataDialog = false
      },
      // 新增确定
      determine() {
        this.downloadLoading = true
        this.$refs.newupload.submit();
      },
      // 下载数据
      downloadSpecialReportTemplat() {
        this.LoadReportTemplat = true
        fetch({
          url: "/hcm/hcmReport/downloadSpecialReportTemplat",
          method: "get",
          noFormat: true,
          responseType: "blob"
        })
        .then((res)=>{
          //下载
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '特殊扣分处理模板.xlsx')
          document.body.appendChild(link)
          link.click()
          this.LoadReportTemplat = false
        })
      },
      // 操作记录
      getLogPage() {
        let params={
          modulename: "KEEP",
          pageNo: 1,
          pageSize: 100000,
        }
        if (this.opreate_realname) {
          params.opreate_realname = this.opreate_realname
        }
        if (this.opreate) {
          params.opreate = this.opreate
        }
        if (this.filename) {
          params.filename = this.filename
        }
        if (this.starttime) {
          params.starttime = this.starttime
        }
        if (this.endtime) {
          params.endtime = this.endtime
        }
        fetch({
          url: "/hcm/cus/getLogPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.logShow = true
            this.logData = res.data.content
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      getRecentDate(picker,n){
        if (!n) {
          n = 90
        }
  			const end = new Date();
  			const start = new Date();
  			start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
  			if(picker){
  				picker.$emit('pick', [start, end]);
        }
        if (n === 1) {
          this.searchformDate[0] = end;
          this.searchformDate[0] = end;
        } else {
          this.searchformDate[0] = start;
          this.searchformDate[1] = end;
        }
  		},
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.theQuery()
      },
      // 翻页
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.theQuery()
      },
      // 数据源
      theQuery() {
        this.dataLoading = true
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        if (this.searchformDate && this.searchformDate[0]) {
          params.starttime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10)
        }
        if (this.searchformDate && this.searchformDate[1]) {
          params.endtime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10)
        }
        if (this.title) {
          params.title = this.title
        }
        fetch({
          url: "hcm/cus/getKeepPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.dataLoading = false
            this.tableData = res.data.content
            this.totalNum = res.data.totalElements
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 序号勾选
      // handleSelectionChange(val) {
      //   this.openNumber = val.length;
      //   this.selectRows = val;
      //   if (this.checkAll == 2) {
      //     this.openNumber = this.totalNum
      //   }
      // },
      handleSelectionChange(val) {
        if (this.checkAll != 2) {
          this.openNumber = val.length;
          this.selectRows = val;
        }
      },
      // 勾选
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleAllSelection(row);
            this.openNumber = this.totalNum
            this.checkAll = 2
            // totalNum
          });
        } else {
          this.$refs.multipleTable.clearSelection();
          this.checkAll = 1
          this.openNumber = 0
        }
      },
      // 删除
      onOpenDeleteDia(e,ids) {
        this.delIds = ''
        if (ids && e == 1) {
          this.delType = '该'
          this.delIds = ids
        } else if (this.checkAll == 2 && e == 2) {
          this.delType = '全部'
          this.delIds = "checkAll"
        } else {
          this.delType = this.openNumber + '条'
          let arrIds = []
          for (let i in this.selectRows) {
            arrIds.push(this.selectRows[i].id)
          }
          this.delIds = arrIds.join(',')
        }
        if (this.delIds == '') {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return
        }
        this.deleteShow = true
      },
      // 取消删除
      delCancel() {
        this.deleteShow = false
        this.delType = ''
        this.checkAll = ''
        this.delIds = ''
      },
      // 确认删除
      deleteClassification() {
        this.ficationLoading = true
        let params = {
          ids: this.delIds,
        }
        if (this.searchformDate && this.searchformDate[0]) {
          params.starttime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10)
        }
        if (this.searchformDate && this.searchformDate[1]) {
          params.endtime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10)
        }
        if (this.title) {
          params.title = this.title
        }
        fetch({
          url: "/hcm/cus/deleteKeep",
          method: "post",
          data: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.ficationLoading = false
            this.deleteShow = false
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.theQuery();
          } else {
            this.$message.error(res.message);
          }
        })
      },
      // 新增/编辑
      newAdd(data) {
        this.editorTitle = '新增'
        this.downDataDialog = true
      },
    },
    components: {
      pagination
    }
  }
</script>
<style lang="scss">
  #retained{
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }
    .page {
      padding: 20px;
      margin: 10px 0px 0px 0px;
      background-color: white;
    }
    .shoptype {
      display: inline-flex;
    	align-items: center;
    	font-size: 14px;
    	color: #fff;
    	border-radius: 3px;
    	padding: 0px 3px;
    	height: 20px;
    	line-height: 20px;
    	margin: 0 0 0 5px;
    	vertical-align: super;
    	 background: #d4d4d4;
    	&.type{
    		background: #d4d4d4;
    	}
      &.type1 {
        background: #52c41a;
      }
      &.type2 {
        background: #d4d4d4;
      }
      &.type3 {
        background: #333333;
      }
      &.type4{
    	background: none;
      }
    }
    #typeDialog {
      .el-upload-dragger {
        width: 560px;
        height: 237px;
      }
    }
    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .downBtn {
      display: flex;
      justify-content: flex-start;
    }
    .prompt {
      height: 28px;
      border: 1px solid #108cee;
      background-color: #e6f7ff;
      border-radius: 5px;
      line-height: 28px;
      margin-top: 8px;
      margin-bottom: 8px;
    }
    .promptFont{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
    }
    .promptFont2{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
      cursor: pointer;
    }
    .plat-item {
    	display: inline-block;
    	margin-left: 5px;
    	border: 1px solid rgb(164, 163, 163);
    	padding: 2px;
      border-radius: 4px;
    }
    .threeHa {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
</style>
